module.exports = __webpack_public_path__ + "static/media/down-chevron.3fc89807.svg";